import { PagePresentation, TacticBlocks } from '@Generated/graphql'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'

export const Blocks = ({ tactic }: { tactic?: TacticBlocks }) => useBlockComponents(tactic?.blocks || [], '', false, PagePresentation.Full)
